import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type StateService from 'garaje/services/state';
import type { AtlasDisplay } from 'garaje/utils/atlas';
import urlBuilder from 'garaje/utils/url-builder';

import type MapsSignageIndexController from './controller';

export interface MapsSignageIndexRouteModel {
  displays: AtlasDisplay[];
}

export default class MapsSignageIndexRoute extends Route {
  @service declare ajax: AjaxFetchService;
  @service declare store: Store;
  @service declare router: RouterService;
  @service declare state: StateService;

  async model(): Promise<MapsSignageIndexRouteModel | void> {
    const displays: AtlasDisplay[] = await this.ajax.request(urlBuilder.mapi.devices.devicesUrl(), {
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        locationId: this.state.currentLocation.id,
      }),
    });

    if (!displays.length) {
      return void this.router.transitionTo('spaces.maps.signage.pair');
    }

    return {
      displays,
    };
  }

  setupController(
    controller: MapsSignageIndexController,
    model: MapsSignageIndexRouteModel,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    controller.displays = model.displays;
  }
}
